import * as pdfjsLib from 'pdfjs-dist/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js`;

/**
 * Reconstruye las filas visuales de un PDF como texto plano.
 *
 * Vivia dentro de LeerPdf/index.js; se extrajo sin cambios para poder reusarla desde la
 * carga de cotizaciones de proveedor (ModalCargarCotizacion), que necesita el texto pero
 * no el componente ni los parsers de lotes.
 *
 * @param {File} file archivo PDF
 * @returns {Promise<string[]>} una cadena por fila visual del documento
 */
export async function extraerLineasDePdf(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const allLines = [];

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const textContent = await page.getTextContent();

    // Agrupar items por fila con tolerancia: pdfjs puede reportar y con pequeñas
    // diferencias de baseline (p.ej. 120.4 vs 120.6) dentro de la misma fila visual.
    // Math.round las separaba y rompía el regex (típicamente lote/caducidad caían en
    // una "línea" distinta a la descripción). Agrupamos con tolerancia ~= mitad de la
    // altura del item para que cada fila se reconstruya completa.
    const itemsByY = textContent.items
      .filter(it => it.str?.trim())
      .map(it => ({
        str: it.str,
        x: it.transform[4],
        y: it.transform[5],
        h: it.height || Math.abs(it.transform[3]) || 10,
      }))
      .sort((a, b) => b.y - a.y);

    const rows = [];
    for (const it of itemsByY) {
      const tol = Math.max(2, it.h * 0.5);
      const row = rows.find(r => Math.abs(r.y - it.y) <= tol);
      if (row) {
        row.items.push(it);
      } else {
        rows.push({ y: it.y, items: [it] });
      }
    }

    for (const row of rows) {
      const lineItems = row.items.sort((a, b) => a.x - b.x);
      const text = lineItems.map(i => i.str).join(' ').replace(/\s+/g, ' ').trim();
      if (text) allLines.push(text);
    }
  }

  return allLines;
}

export default extraerLineasDePdf;
